import { createContext } from "react";
import { EMPTY_FUNCTION } from "@super-ui/components/m2c-swiggy-one-halfcard/constants";

export interface M2CHalfcardContextValue {
    analyticsEvents: {
        onImpressionM2CHalfcard: (title: string, key: string) => void;
        onImpressionM2CHalfcardAddCta: (ctaText: string) => void;
        onImpressionM2CHalfcardSkipCta: (ctaText: string) => void;
        onClickM2CHalfcardAddCta: (ctaText: string) => void;
        onClickM2CHalfcardSkipCta: (ctaText: string, title?: string, content?: string) => void;
        onClickM2CHalfcardViewAllBenefitsCta: (ctaText: string, ctaLink: string) => void;
        onImpressionM2CHalfcardGratification: (title?: string, content?: string) => void;
    };
    halfcardMountDelay?: number;
    frequencyCappingKey?: string;
    deliveryExacutive?: string;
    sessionId?: string;
    gratificationCardAutoCloseDelay?: number;
}

export const DEFAULT_VALUE: M2CHalfcardContextValue = {
    analyticsEvents: {
        onImpressionM2CHalfcard: EMPTY_FUNCTION,
        onImpressionM2CHalfcardAddCta: EMPTY_FUNCTION,
        onImpressionM2CHalfcardSkipCta: EMPTY_FUNCTION,
        onClickM2CHalfcardAddCta: EMPTY_FUNCTION,
        onClickM2CHalfcardSkipCta: EMPTY_FUNCTION,
        onClickM2CHalfcardViewAllBenefitsCta: EMPTY_FUNCTION,
        onImpressionM2CHalfcardGratification: EMPTY_FUNCTION,
    },
    halfcardMountDelay: 0,
    frequencyCappingKey: "",
    deliveryExacutive: "",
    sessionId: "",
};

export const M2CHalfcardContext = createContext<M2CHalfcardContextValue>(DEFAULT_VALUE);
